module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2019/may-f01aa75618c2e1107e706433f3219692.png";